'use client';

import type { ReactNode } from 'react';
import React from 'react';
import { useModalProvider } from '@dr-pam/common-components/Components/Modal/ModalProvider';
import { showGetAccessModal } from './GetAccessModal';

type SignUpButtonProps = {
	className?: string;
	children?: ReactNode;
};

export default function SignUpButton({ className, children }: SignUpButtonProps) {
	const modalProvider = useModalProvider();

	return (
		<button type="button" className={className} onClick={() => showGetAccessModal(modalProvider)}>
			{children}
		</button>
	);
}
